{
  "RESET_PASSWORD": {
    "TITLE": "Atiestatīt paroli",
    "DESCRIPTION": "Ievadiet e-pasta adresi, kuru izmantojat lai pieteiktos Chatwoot, lai saņemtu paroles atiestatīšanas norādījumus.",
    "GO_BACK_TO_LOGIN": "Ja vēlaties atgriezties uz pieteikšanās lapu,",
    "EMAIL": {
      "LABEL": "E-pasts",
      "PLACEHOLDER": "Lūdzu, ievadiet savu e-pastu.",
      "ERROR": "Lūdzu, ievadiet derīgu e-pasta adresi."
    },
    "API": {
      "SUCCESS_MESSAGE": "Paroles atiestatīšanas saite ir nosūtīta uz jūsu e-pastu.",
      "ERROR_MESSAGE": "Nevarēja izveidot savienojumu ar Woot serveri. Lūdzu mēģiniet vēlreiz."
    },
    "SUBMIT": "Iesniegt"
  }
}
